import { useState, useEffect } from '@wordpress/element';
import { __ } from "@wordpress/i18n";
import apiFetch from "@wordpress/api-fetch";
import { Routes, Route, Navigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { Alert, Button, Container, Row, Col, Badge, Modal, Form, FloatingLabel } from 'react-bootstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faStar, faGear, faTableColumns, faWebAwesome, faSun, faMoon, faComment, faBell, faMagnifyingGlass, faClose, faHeadphones, faQuestion, faUser, faSpinner } from '@fortawesome/free-solid-svg-icons';

import { useSettingsBodyHeight } from './lib/Helpers';
import { Logo } from './lib/Illustrations';
import Details from './data/details.json';
import { HorizontalMultiLevelNavbar } from './components/Menu/Menu';
import {useWindowWidth, setNestedValue} from './lib/Helpers'
import menuItems from './data/menu.json';
import { getMenu } from './data/menu.js';

import { Dashboard, Settings, BuyNow, BuyTogether, AddonItems, ProductBadge, ProductPlacement, ContentPlacement, MyAccountDashboard, CatalogMode, ImportExport, Feedback, FreeVsPro, Tools, LogsCharts, LogsTable } from './pages';

import NotFound from './NotFound';
import { ToastControl } from './components/index.js';

const year = new Date().getFullYear();

const pathPrefix = 'admin.php?page=store-addons-for-woocommerce#'; // Adjust this if your app is served from a different base path
export default function App() {
    const location = useLocation();
    const currentPath = location.pathname;

    const width = useWindowWidth();
    const hasHiddenMenues = width <= 991; 

    const [darkmode, setDarkmode] = useState(false);
    useEffect(() => {
        const fetchSettingTheme = async () => {
            try {
                const params = new URLSearchParams({
                    id: store_addons_for_woocommerce_ajax_obj.get_current_user_id,
                });
                const theme = await apiFetch({
                    path: `/store-addons-for-woocommerce/v1/get-settings-theme?${params.toString()}`,
                    method: 'GET'
                });
                const isDark = theme === 'dark' || (theme && theme.value === 'dark');
                setDarkmode(isDark);
                document.documentElement.setAttribute('data-bs-theme', isDark ? 'dark' : 'light');
            } catch (err) {
                console.error('API error:', err);
            }
        };
        fetchSettingTheme();
    }, []);

    const switchingMode = async () => {
        const switchMode = !darkmode;
        setDarkmode(switchMode);
        document.documentElement.setAttribute('data-bs-theme', switchMode ? 'dark' : 'light');
        try {
            const params = new URLSearchParams({
                id: store_addons_for_woocommerce_ajax_obj.get_current_user_id,
                settings_theme: switchMode ? 'dark' : 'light',
            });
            await apiFetch({
                path: `/store-addons-for-woocommerce/v1/set-settings-theme?${params.toString()}`,
            });
        } catch (error) {
            console.error("Error fetching settings data:", error);
        }
    };


    const [ProPluginNews, setProPluginNews] = useState(null);
    const [ProMore, setProMore] = useState(null);
    const [ProPropsPassing, setProPropsPassing] = useState(null);
    const [ProBridge, setProBridge] = useState(null);

    useEffect(() => {
        // Check if the Pro version has loaded its global component hook
        if (window.StoreAddonsForWoocommerceProComponents && window.StoreAddonsForWoocommerceProComponents.PluginNews) {
            setProPluginNews(() => window.StoreAddonsForWoocommerceProComponents.PluginNews);
        }
        // console.log('Feedback component mounted. ProPluginNews available:', !!window.StoreAddonsForWoocommerceProComponents?.PluginNews);

        // Check if the Pro version has loaded its global component hook
        if (window.StoreAddonsForWoocommerceProComponents && window.StoreAddonsForWoocommerceProComponents.More) {
            setProMore(() => window.StoreAddonsForWoocommerceProComponents.More);
        }
        // console.log('Feedback component mounted. ProPluginNews available:', !!window.StoreAddonsForWoocommerceProComponents?.More);

        // Check if the Pro version has loaded its global component hook
        if (window.StoreAddonsForWoocommerceProComponents && window.StoreAddonsForWoocommerceProComponents.PropsPassing) {
            setProPropsPassing(() => window.StoreAddonsForWoocommerceProComponents.PropsPassing);
        }
        // console.log('Feedback component mounted. ProPluginNews available:', !!window.StoreAddonsForWoocommerceProComponents?.PropsPassing);

        // Check if the Pro version has loaded its global component hook
        if (window.StoreAddonsForWoocommerceProComponents && window.StoreAddonsForWoocommerceProComponents.Bridge) {
            setProBridge(() => window.StoreAddonsForWoocommerceProComponents.Bridge);
        }
        // console.log('Feedback component mounted. ProPluginNews available:', !!window.StoreAddonsForWoocommerceProComponents?.Bridge);
    }, []);


    const [newsItems, setNewsItems] = useState([]);
    const [newsVisible, setNewsVisible] = useState(false);
    if (store_addons_for_woocommerce_ajax_obj?.isPro === '1') {
        useEffect(() => {
            const fetchNews = async () => {
                try {
                    // Sends data directly to the native WordPress custom REST API endpoint
                    const response = await apiFetch({
                        path: '/store-addons-for-woocommerce-pro/v1/news',
                        method: 'GET'
                    });
                    setNewsItems(response);
                } catch (error) {
                    console.error("Error fetching news:", error);
                }
            };
            fetchNews();
        }, []);
    }


    const [showModal, setShowModal] = useState(false);
    const [search, setSearch] = useState('');
    const [searching, setSearching] = useState(false);
    const [searchResult, setSearchResult] = useState([]);
    const modalClose = () => {
        setShowModal(false);
        setSearch('');
        setSearchResult([]);
    }
    const modalShow = () => setShowModal(true);
    useEffect(() => {

        // 1. Don't search if the input is empty
        if (!search.trim()) {
            setSearchResult([]);
            return;
        }

        // 2. Create an AbortController to cancel this request if input changes again
        const controller = new AbortController();
        const { signal } = controller;

        // 3. Set up the debounce timer
        const delayDebounceFn = setTimeout(async () => {
            setSearching(true);
            try {
                const params = new URLSearchParams({
                    search: search,
                });
                const result = await apiFetch({
                    path: `/store-addons-for-woocommerce/v1/options-details?${params.toString()}`,
                    method: 'GET'
                });
                setSearchResult(result)
            } catch (error) {
                if (error.name !== 'AbortError') {
                console.error('Search error:', error);
                }
            } finally {
                setSearching(false);
            }
        }, 300); // 300ms wait time

        // 4. Cleanup function: runs when searchTerm changes or component unmounts
        return () => {
            clearTimeout(delayDebounceFn);
            controller.abort();
        };

        // const doSearch = async () => {
        //     try {
        //         const params = new URLSearchParams({
        //             search: search,
        //         });
        //         const result = await apiFetch({
        //             path: `/store-addons-for-woocommerce/v1/options-details?${params.toString()}`,
        //             method: 'GET'
        //         });
        //         if (result) {
        //             setSearchResult(result)
        //         }
        //     } catch (err) {
        //         console.error('API error:', err);
        //     }
        // };
        // if (search.length > 3) doSearch();
    }, [search]);

    const [proItems, setProItems] = useState([]);
    const [remoteItems, setRemoteItems] = useState([]);

    useEffect(() => {
        // Check if the Pro version has loaded its global component hook
        if (window.StoreAddonsForWoocommerceProComponents && window.StoreAddonsForWoocommerceProComponents.menuItems) {
            setProItems(() => window.StoreAddonsForWoocommerceProComponents.menuItems);
        }
    }, []);
    
    // Optional: load remote injected menu items
    useEffect(() => {
        if (store_addons_for_woocommerce_ajax_obj?.extraMenuItems) {
            setRemoteItems(store_addons_for_woocommerce_ajax_obj.extraMenuItems);
        }
    }, []);

    // Get dynamic settings menu items
    const settingsMenuData = getMenu({ baseMenu: menuItems, proItems, remoteItems });

    const HorizontalMenuItems = [
        { 
            itemKey: 'settings', 
            text: 'Settings', 
            icon: <FontAwesomeIcon icon={faGear} />, 
            url: '/settings',
            className: `${currentPath.startsWith('/settings/') ? 'current' : ''}`.trim(),
            // items: hasHiddenMenues?settingsMenuData:[] // <-- Bind the dynamic Settings menu items here!
            ...(hasHiddenMenues ? { items: settingsMenuData } : {}) // <-- Submenu only below 991px
            // ...(hasHiddenMenues && [{items: settingsMenuData}] )
        },
        { itemKey: 'feedback', text: 'Feedback', icon: <FontAwesomeIcon icon={faComment} />, url: '/feedback' },

        // ...(!store_addons_for_woocommerce_ajax_obj?.isPro ? [{ itemKey: 'free-vs-pro', text: 'Free vs Pro', icon: <FontAwesomeIcon icon={faWebAwesome} />, url: '/free-vs-pro' }] : []),
    ];




    const [showToast, setShowToast] = useState(false);
    const [dataToast, setDataToast] = useState({ title: '', content: '', type: 'success' });
    const toggleShowToast = () => setShowToast(!showToast);

    const [settings, setSettings] = useState({});
    const [settingsDetails, setSettingsDetails] = useState({});
    const [settingsLoading, setSettingsLoading] = useState(false);
    const [settingsReload, setSettingsReload] = useState(0);    
    
    useEffect(() => {
        const fetchSettings = async () => {
            setSettingsLoading(true);
            try {
                // Both requests start at the exact same time
                const [data, dataDetails] = await Promise.all([
                    apiFetch({ path: '/store-addons-for-woocommerce/v1/options' }),
                    apiFetch({ path: '/store-addons-for-woocommerce/v1/options-details' })
                ]);
                if (data && dataDetails) {
                    setSettings(data);
                    setSettingsDetails(dataDetails);
                }
            } catch (error) {
                console.error("Error fetching settings:", error);
                setDataToast({
                    title: __("Error", "store-addons-for-woocommerce"),
                    content: __("Error fetching settings", "store-addons-for-woocommerce"),
                    type: 'danger'
                });
                setShowToast(true);
            } finally {
                setSettingsLoading(false);
            }
        };
        fetchSettings();
    }, [settingsReload]);    
    
    const handleChange = (fieldPath, value) => {
        setSettings(prev => {
            const updatedOptions = setNestedValue(prev, fieldPath, value);
            return { ...updatedOptions }; // Ensure React detects the update
        });
    };

    //settings, settingsDetails, settingsLoading, handleChange, setSettingsReload

    return (
        <div className="store-addons-for-woocommerce-settings-container">
            {/* {!store_addons_for_woocommerce_ajax_obj?.isPro &&
                <div className="store-addons-for-woocommerce-promote-banner">
                    <Alert variant='info' className='rounded-0 mb-0'>
                        {__('You\'re currently using the Free plan. ', 'store-addons-for-woocommerce')}
                        {__('Some settings and features are only available in ', 'store-addons-for-woocommerce')}
                        <a className="link-underline link-underline-opacity-0" href={store_addons_for_woocommerce_ajax_obj?.proURL} target="_blank" rel="noopener noreferrer">{__('the Pro version.', 'store-addons-for-woocommerce')}</a>
                    </Alert>
                </div>
            } */}
            {/* Main Navigation Header */}
            <header className="store-addons-for-woocommerce-header border-bottom">
                <HorizontalMultiLevelNavbar
                    MenuItems={HorizontalMenuItems}
                    headerContent={{
                        logo: <Logo width={36} height={36} />,
                        text: Details?.name,
                    }}
                    footerContent={(
                        <div className="header-icon-menu d-flex align-items-center gap-2 pe-2">
                            <Button
                                className='d-none d-lg-inline-block'
                                variant="outline-secondary"
                                size="sm"
                                aria-label={__("Seach", 'store-addons-for-woocommerce')}
                                onClick={modalShow}
                            >
                                <FontAwesomeIcon icon={faMagnifyingGlass} />
                            </Button>
                            <Button
                                className='d-none d-lg-inline-block'
                                variant="outline-secondary"
                                size="sm"
                                aria-label="Mode"
                                onClick={switchingMode}
                            >
                                {darkmode ? <FontAwesomeIcon icon={faSun} /> : <FontAwesomeIcon icon={faMoon} />}
                            </Button>
                            <Button
                                className='d-inline-block d-lg-none'
                                variant="outline-secondary"
                                size="sm"
                                aria-label={__("VIP Priority Support", 'store-addons-for-woocommerce')}
                                onClick={() => window.open('https://wordpress.org/support/plugin/store-addons-for-woocommerce/', '_blank')}
                            >
                                <FontAwesomeIcon icon={faHeadphones} />
                            </Button>
                            <Button
                                className='d-inline-block d-lg-none'
                                variant="outline-secondary"
                                size="sm"
                                aria-label={__("Help Center", 'store-addons-for-woocommerce')}
                                onClick={() => window.open('https://mostak-shahid.github.io/plugins/store-addons-for-woocommerce.html', '_blank')}
                            >
                                <FontAwesomeIcon icon={faQuestion} />
                            </Button>
                            <Button
                                className='d-inline-block d-lg-none'
                                variant="outline-secondary"
                                size="sm"
                                aria-label={__("Community", 'store-addons-for-woocommerce')}
                                onClick={() => window.open('https://www.facebook.com/mospressbd', '_blank')}
                            >
                                <FontAwesomeIcon icon={faUser} />
                            </Button>

                            <Button
                                className='d-inline-block d-lg-none'
                                variant="outline-secondary"
                                size="sm"
                                aria-label={__("Help Center", 'store-addons-for-woocommerce')}
                                onClick={() => window.open('https://wordpress.org/support/plugin/store-addons-for-woocommerce/reviews/', '_blank')}
                            >
                                <FontAwesomeIcon icon={faStar} />
                            </Button>
                            {store_addons_for_woocommerce_ajax_obj?.isPro &&
                                <div className="position-relative">
                                    <Button
                                        className='d-none d-lg-inline-block'
                                        variant="outline-secondary"
                                        size="sm"
                                        onClick={() => setNewsVisible(true)} aria-label="News"
                                    >
                                        <FontAwesomeIcon icon={faBell} />
                                    </Button>
                                    {newsItems.length > 0 && (
                                        <Badge bg="danger" className="position-absolute top-0 start-100 translate-middle">
                                            {newsItems.length > 99 ? '99+' : newsItems.length}
                                        </Badge>
                                    )}
                                </div>
                            }
                        </div>
                    )}
                    toggleContent={(
                        <div className="header-icon-menu d-flex align-items-center gap-2 pe-2">
                            <Button
                                variant="outline-secondary"
                                size="sm"
                                aria-label={__("Seach", 'store-addons-for-woocommerce')}
                                onClick={modalShow}
                            >
                                <FontAwesomeIcon icon={faMagnifyingGlass} />
                            </Button>
                            <Button
                                variant="outline-secondary"
                                size="sm"
                                aria-label="Mode"
                                onClick={switchingMode}
                            >
                                {darkmode ? <FontAwesomeIcon icon={faSun} /> : <FontAwesomeIcon icon={faMoon} />}
                            </Button>
                            {store_addons_for_woocommerce_ajax_obj?.isPro &&
                                <div className="position-relative">
                                    <Button
                                        variant="outline-secondary"
                                        size="sm"
                                        onClick={() => setNewsVisible(true)} aria-label="News"
                                    >
                                        <FontAwesomeIcon icon={faBell} />
                                    </Button>
                                    {newsItems.length > 0 && (
                                        <Badge bg="danger" className="position-absolute top-0 start-100 translate-middle">
                                            {newsItems.length > 99 ? '99+' : newsItems.length}
                                        </Badge>
                                    )}
                                </div>
                            }
                        </div>
                    )}
                />
            </header>
            {/* Dynamic Dashboard Viewport */}
            <main className="store-addons-for-woocommerce-content">
                {ProPluginNews && <ProPluginNews showOffcanvas={newsVisible} setShowOffcanvas={setNewsVisible} />}

                <Routes>
                    {/* <Route path="/" element={<Dashboard />} /> */}
                    <Route path="/" element={<Navigate to="settings/general/catalog_mode" replace />} />
                    {/* <Route path="/settings" element={<Settings />} /> */}
                    <Route path="/settings" element={<Settings settings={settings} settingsDetails={settingsDetails} settingsLoading={settingsLoading} handleChange={handleChange} settingsReload={settingsReload} setSettingsReload={setSettingsReload} />}>
                        <Route index element={<Navigate to="general/catalog_mode" replace />} />
                        <Route path="general/catalog_mode" element={<CatalogMode/>} />
                        <Route path="archive/product_badge" element={<ProductBadge/>} />
                        <Route path="product/buy_now_button" element={<BuyNow/>} />
                        <Route path="product/buy_together" element={<BuyTogether/>} />
                        <Route path="product/addon_items" element={<AddonItems/>} />
                        <Route path="checkout/product_placement" element={<ProductPlacement/>} />
                        <Route path="cart/content_placement" element={<ContentPlacement/>} />
                        <Route path="account/dashboard" element={<MyAccountDashboard/>} />

                        <Route path="utilities" element={<Navigate to="import_export" replace />} />
                        <Route path="utilities/import_export" element={<ImportExport />} />
                        <Route path="utilities/tools" element={<Tools />} />
                        <Route path="utilities/logs" element={<Navigate to="table" replace />} />
                        <Route path="utilities/logs/table" element={<LogsTable />} />
                        <Route path="utilities/logs/analytics" element={<LogsCharts />} />

                        {ProMore && <Route path="more" element={<ProMore />} />}
                    </Route>

                    <Route path="/feedback" element={<Feedback />} />
                    <Route path="/free-vs-pro" element={<FreeVsPro />} />
                    {/* <Route path="*" element={<Navigate replace to="/" />} /> */}
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </main>


            <footer className="store-addons-for-woocommerce-footer border-top" style={{ backgroundColor: 'var(--bs-body-bg)' }}>
                <Container fluid={true}>
                    <Row className="align-items-center justify-content-between py-3">
                        <Col xs={12} lg={6} className="text-center text-lg-start mb-2 mb-lg-0">
                            <span>{__(`Copyright © ${year} `, 'store-addons-for-woocommerce')}</span>
                            <a href={Details?.authorURI} target="_blank" rel="noopener noreferrer">{Details?.author}.</a>
                            <span>{__(` All Rights Reserved.`, 'store-addons-for-woocommerce')}</span>
                        </Col>
                        <Col xs={12} lg={6} className="text-center text-lg-end">
                            <div className="d-flex align-items-center justify-content-center justify-content-lg-end gap-2 flex-wrap">
                                {store_addons_for_woocommerce_ajax_obj?.isPro === '1' ? (
                                    <>
                                        <Badge bg="warning" text="dark">{__('Pro', "store-addons-for-woocommerce")}</Badge>
                                        <Badge bg="info">{store_addons_for_woocommerce_ajax_obj?.proVersion}</Badge>
                                    </>
                                ) : (
                                    <>
                                        <Badge bg="secondary">{__('Free', "store-addons-for-woocommerce")}</Badge>
                                        <Badge bg="info">{Details?.version}</Badge>
                                    </>
                                )}
                            </div>
                        </Col>
                    </Row>
                </Container>
            </footer>
            <Modal show={showModal} onHide={modalClose}>
                <Modal.Body>
                    <FloatingLabel
                        controlId="settings-search"
                        label={__('Search Settings', 'store-addons-for-woocommerce')}
                        // className="mb-3"
                    >
                        <Form.Control type="search" placeholder={__('Search Settings', 'store-addons-for-woocommerce')} value={search} onChange={(e) => setSearch(e.target.value)} />
                    </FloatingLabel>
                    {
                        searching && <div className="text-center border rounded-2 mt-2 p-3"><FontAwesomeIcon icon={faSpinner} className='fa-spin-pulse'/></div>
                    }
                    {searchResult.length ? 
                        <div className='search-results border rounded-2 mt-2'>
                            {searchResult.map((item, index) => (
                                <a 
                                    key={index} 
                                    href={pathPrefix + item.url}
                                    className='btn d-block p-2 border-bottom text-start rounded-0'
                                    onClick={modalClose}
                                >
                                    <span className='link-title d-block fw-semibold'>{item.title}</span>
                                    <span className='link-url d-block'>{item.url}</span>
                                </a>
                            ))}
                        </div>
                    : ''}
                </Modal.Body>
            </Modal>

            <ToastControl
                show={showToast}
                onClose={toggleShowToast}
                data={dataToast}
            />
        </div>
    );
}
